module.exports = __webpack_public_path__ + "img/circle_edit_outline.db266a16.svg";